import { IGeofence, isIGeofence } from '@iotv/iotv-v3-types'

export interface GeoJsonPolygon {}

export type { IGeofence }

export { isIGeofence }
